import { render } from "./close-button-header.vue?vue&type=template&id=544a5f05&scoped=true&ts=true"
import script from "./close-button-header.vue?vue&type=script&lang=ts"
export * from "./close-button-header.vue?vue&type=script&lang=ts"

import "./close-button-header.vue?vue&type=style&index=0&id=544a5f05&scoped=true&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544a5f05"]])

export default __exports__